module.exports = __webpack_public_path__ + "static/media/notifications_enable_help.b7933642.jpg";